import { render, staticRenderFns } from "./MyAccountRoute.vue?vue&type=template&id=2dd13606&"
import script from "./MyAccountRoute.vue?vue&type=script&lang=ts&"
export * from "./MyAccountRoute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports